<template>
  <button type="button" class="btn-card" :class="btnColor">
    <i class="fa" :class="faName"></i>
    <span class="btn-card__counter" style="font-size: 20px">{{ counter }}</span>
    <span><slot></slot></span>
  </button>
</template>
<script>
export default {
  props: {
    faName: {
      type: String,
      required: true,
    },
    btnColor: {
      type: String,
      required: true,
    },
    counter: {
      required: true,
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/ButtonCard.vue